var getBuiltIn = require('../internals/get-built-in');

module.exports = getBuiltIn('navigator', 'userAgent') || '';



//////////////////
// WEBPACK FOOTER
// /tmp/build_310c34ba/node_modules/core-js/internals/engine-user-agent.js
// module id = 51
// module chunks = 2